import { render, staticRenderFns } from "./DropDiv.vue?vue&type=template&id=0ce64ba2&"
import script from "./DropDiv.vue?vue&type=script&lang=js&"
export * from "./DropDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports